import { missingFieldsAlert } from "@/api/errorMessages";

function validationQuote(quote) {
  let sendQuote = false;
  let fieldsChecked = 0;
  for (let haul of quote) {
    if (haul.customer_id !== null && haul.customer_id !== "") {
      if (haul?.tms_mode?.id) {
        if (
          haul.zip_from !== null &&
          haul.zip_from !== "" &&
          haul.city_from !== null &&
          haul.city_from !== "" &&
          haul.state_from !== null &&
          haul.state_from !== "" &&
          haul.zip_to !== null &&
          haul.zip_to !== "" &&
          haul.city_to !== null &&
          haul.city_to !== "" &&
          haul.state_to !== null &&
          haul.state_to !== ""
        ) {
          let currentDepartment = JSON.parse(
            localStorage.getItem("current-department")
          );
          if (currentDepartment?.department_name === "TC") {
            if (!haul?.equipment_type) {
              missingFieldsAlert("Please, Select an Equipment Type.");
              break;
            }
          }
          if (haul.commodity.length > 0) {
            let commoditiesFields = haul.commodity;
            let rowsChecked = 0;
            for (let commodity of commoditiesFields) {
              if (
                commodity.hu_count !== null &&
                commodity.hu_count !== "" &&
                commodity.dimensions !== null &&
                commodity.dimensions !== "" &&
                commodity.weight !== null &&
                commodity.weight !== ""
              ) {
                rowsChecked += 1;
                if (rowsChecked === commoditiesFields.length) {
                  fieldsChecked += 1;
                }
              } else {
                missingFieldsAlert(
                  "Please, provide all the information about the items in all trips."
                );
                break;
              }
            }
          } else {
            missingFieldsAlert(
              "Please, provide all the information about the items in all trips."
            );
          }
        } else {
          missingFieldsAlert(
            "Cities, States, Zip Codes and Totals are required in all trips."
          );
        }
      } else {
        missingFieldsAlert("Mode field is required in all trips.");
      }
    } else {
      missingFieldsAlert("Customer field is required in all trips.");
    }
  }
  if (fieldsChecked === quote.length) {
    sendQuote = true;
    return sendQuote;
  }
  return sendQuote;
}

function disableByAssigned(rowInfo, infoUsername, routePath) {
  let fieldDisabled = null;
  if (
    !rowInfo.message_alert &&
    rowInfo.entry_type !== "Manual" &&
    (rowInfo.assigned_to === null ||
      (rowInfo.superuser_role == true && rowInfo.assigned_to == infoUsername) ||
      routePath === "/myQueue")
  ) {
    fieldDisabled = false;
  } else {
    fieldDisabled = true;
  }
  return fieldDisabled;
}

function infoEmailCondition(user, pathName, item) {
  let condition =
    ((user[0].rol.id === 3 &&
      (pathName === "queue" ||
        (pathName === "alerts" && item.message.not_quote)) &&
      (item.message.user == null ||
        item.message.user.username == user[0].user.username)) ||
      (user[0].rol.id === 2 &&
        pathName === "myQueue" &&
        item.message.user.username == user[0].user.username)) &&
    !item.message.validation_alert &&
    !item.message.html_response &&
    item.message.entry_type !== "Manual";
  return condition;
}

function listTableCondition(user, items, path) {
  let condition =
    ((user[0].rol.id === 3 &&
      (path === "/queue" || path === "/spanish-queue") &&
      (items.assigned_to == null ||
        (items.superuser_role == true &&
          items.assigned_to == user[0].user.username))) ||
      (user[0].rol.id === 2 &&
        path === "/myQueue" &&
        items.assigned_to == user[0].user.username)) &&
    !items.message_alert &&
    items.entry_type !== "Manual";
  return condition;
}

function validateRoutes(routesArray, currentRoute) {
  return routesArray.some(route => route === currentRoute);
}

function validateComponents(
  nameComponent,
  isLTLDepartmentId,
  isSuperUserRolName,
  currentPathNameRoute,
  currentPathRoute,
  hideOptions
) {
  if (nameComponent === "alertTabs") {
    return (
      isLTLDepartmentId &&
      isSuperUserRolName &&
      currentPathNameRoute == "alerts"
    );
  }
  if (nameComponent === "createQuoteButton") {
    return (
      isLTLDepartmentId &&
      ((isSuperUserRolName && currentPathRoute === "/queue") ||
        currentPathRoute === "/myQueue")
    );
  }
  if (nameComponent === "sendToNonButton") {
    const routes = ["/queue", "/myQueue", "/spanish-queue"];
    return validateRoutes(routes, currentPathRoute);
  }
  if (nameComponent === "multipleAssignButton") {
    const routes = ["/queue", "/unknown"];
    return (
      hideOptions &&
      validateRoutes(routes, currentPathRoute) &&
      !isSuperUserRolName
    );
  }
}

function validateTableComponents(
  nameComponent,
  index,
  isLTLDepartmentId,
  isSuperUserRolName,
  currentPathRoute,
  hideOptions,
  availableUsers,
  items,
  alertName
) {
  if (nameComponent === "assignToButton") {
    const routes = ["/failed", "/spanish-queue"];
    return (
      hideOptions &&
      availableUsers &&
      isLTLDepartmentId &&
      isSuperUserRolName &&
      (items[index].assigned_to == null ||
        items[index].superuser_role == true) &&
      ((currentPathRoute == "/queue" && !items[index].message_alert) ||
        validateRoutes(routes, currentPathRoute) ||
        (currentPathRoute == "/alerts" && alertName == "Alerts"))
    );
  }
  if (nameComponent === "assignMeButton") {
    const routes = ["/queue", "/spanish-queue", "/unknown"];
    return (
      hideOptions &&
      !isSuperUserRolName &&
      items[index].assigned_to == null &&
      validateRoutes(routes, currentPathRoute)
    );
  }
}

export {
  validationQuote,
  disableByAssigned,
  infoEmailCondition,
  listTableCondition,
  validateRoutes,
  validateComponents,
  validateTableComponents
};
